export const previewConfig = [
  { id: 'quality', content: null },
  {
    id: 'main',
    content: null,
    step_number: 1,
    pathEdition: '/main'
  },
  {
    id: 'location',
    content: null,
    pathEdition: '/location',
    step_number: 2
  },
  {
    id: 'multimedia',
    content: null,
    pathEdition: '/multimedia',
    step_number: 3
  },
  {
    id: 'features',
    content: null,
    pathEdition: '/features',
    step_number: 4
  },
  {
    id: 'extras',
    content: null,
    pathEdition: '/extras',
    step_number: 5
  },
  {
    id: 'description',
    content: null,
    pathEdition: '/description',
    step_number: 6
  },
  {
    id: 'price',
    content: null,
    pathEdition: '/price',
    step_number: 7
  },
  {
    id: 'publication',
    content: null,
    pathEdition: '/publish',
    step_number: 8
  }
];
